var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShiftLogoPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 34,
    viewBox: "0 0 160 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xEB\xA0\x88\xEC\x9D\xB4\xEC\x96\xB4_1",
    clipPath: "url(#clip0_5699_3852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0383 14.3977L13.0929 13.6651C10.2837 13.0241 7.79221 11.9303 7.8376 9.55439C7.88299 7.36166 9.78439 5.75909 13.2291 5.75909C16.6738 5.75909 18.6206 7.31079 18.893 9.91561H25.4192C25.3285 4.07003 20.522 0 13.2745 0C6.02698 0 0.862439 3.97845 0.862439 10.0072C0.862439 14.8505 4.26176 17.6385 9.78943 19.0121L13.3703 19.8821C16.9512 20.7978 18.9888 21.8459 18.9888 24.0844C18.9888 26.5518 16.6789 28.2409 13.098 28.2409C9.51709 28.2409 6.84403 26.5518 6.61707 23.2144H0C0.181566 30.2963 5.25533 34 13.1837 34C21.1121 34 25.8681 30.1589 25.8681 24.0844C25.8681 18.5542 21.6568 15.6747 16.0383 14.3977Z",
    fill: "#A572AB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M55.9276 14.1689H41.6998V0.458008H34.9062V33.5473H41.6998V19.8364H55.9276V33.5473H62.7665V0.458008H55.9276V14.1689Z",
    fill: "#A572AB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M79.6823 0.458008H72.8887V33.5473H79.6823V0.458008Z",
    fill: "#A572AB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M148.813 0.458008H142.019H130.833V7.31092H142.019V33.5473H148.813V7.31092H160V0.458008H148.813Z",
    fill: "#A572AB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M89.8096 0.458008V7.31092V33.5473H96.6032V11.5234L115.536 30.622L120.343 25.7736L102.04 7.31092H122.239V0.458008H96.6032H89.8096Z",
    fill: "#A572AB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5699_3852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftLogoPurple);
export default __webpack_public_path__ + "static/media/ShiftLogo_Purple.e79197dc556c0d2f5317996af3d363cb.svg";
export { ForwardRef as ReactComponent };